import logger from '@/utils/client-logger';
import { useTranslations } from 'next-intl';
import SavedPrescriptionItemForm from './SavedPrescriptionItemForm.pc';
import { Prescription } from '@/api/types/account';
import WebOnly from '@/components/Responsive/WebOnly';
import SavedPrescriptionItemFormM from './SavedPrescriptionItemForm.m';
import WapOnly from '@/components/Responsive/WapOnly';

export default function PrescriptionTablePC({
  prescription,
  showImage = false,
  showHeaderInfo = false,
  showGray = false,
  showError = false,
  isShowForm = false,
  wrapperClassName = '',
  customHeader,
  onSelectPrescription,
}: {
  prescription: Prescription;
  showImage?: boolean;
  showHeaderInfo?: boolean;
  showGray?: boolean;
  showError?: boolean;
  isShowForm?: boolean;
  wrapperClassName?: string;
  customHeader?: () => React.ReactNode;
  onSelectPrescription: () => void;
}) {
  const t = useTranslations('account.myPrescriptions');
  logger.info('prescription', showImage, showHeaderInfo);

  const getPrescriptionType = (str: string, prescriptionTypeName: string) => {
    if (str === 'Sunglasses Prescription') {
      return t('prescriptionTypes.sunglasses');
    }

    return prescriptionTypeName;
  };
  const prescriptionFormatter = () => {
    // 处方数据格式化
    const _prescription = { ...prescription };
    ['od_sph', 'os_sph', 'od_cyl', 'os_cyl', 'od_add', 'os_add'].forEach((item) => {
      const value = prescription.prescription[item];

      // 如果是空值（null、undefined、空字符串、或只有空格），显示中划线
      if (!value || value.toString().trim() === '') {
        _prescription.prescription[item] = '-';
        return;
      }

      const reg = /[^0-9.]/g;
      if (!reg.test(value) && value !== '0.00') {
        _prescription.prescription[item] = `+${value}`;
      }
    });
    return _prescription;
  };
  return (
    <article
      className={`prescription-card border border-[#d4d4d4] rounded-12 p-20 bg-white ${wrapperClassName}`}
      onClick={onSelectPrescription}
    >
      <div className="flex justify-between items-start">
        {customHeader ? (
          customHeader()
        ) : (
          <>
            <header className="flex flex-col flex-1">
              <strong className="f18 font-bs mr-10">{prescription.name}</strong>
              <time className="text-14 mt-4 font-br text-secondary-text">
                {prescription.updated_at}
              </time>
            </header>
            <span className="text-12 font-br text-primary-purple bg-[#0006cf1a] rounded-4 overflow-hidden pl-8 pr-8 py-4">
              {getPrescriptionType(
                prescription.prescription_type,
                prescription.prescription_type_name || prescription.prescription_type,
              )}
            </span>
          </>
        )}
      </div>

      {isShowForm && (
        <>
          <WebOnly>
            <SavedPrescriptionItemForm
              prescription={prescriptionFormatter()}
              showGray={showGray}
              showError={showError}
              showImage
              isReadOnly
            />
          </WebOnly>
          <WapOnly>
            <SavedPrescriptionItemFormM
              prescription={prescriptionFormatter()}
              showGray={showGray}
              showError={showError}
              isReadOnly
              showImage
            />
          </WapOnly>
        </>
      )}
    </article>
  );
}
